import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer'
import {
  CommonResponses,
  ElementType,
  NumberFormat,
  SelectCombos,
  SelectCombosPABS,
} from '../Enums/constants';
import SurveyConditionalSegment from "../components/SurveyConditionalSegment";

export const PabsLgTransactionsTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea pageName="Transactions" />
      <SurveyContentContainer>
        <SurveySection
          id="1"
          labelText="Pension Payments"
          helpText="<b>Pension Payments</b> <br><br> 1.  Paying (but not incepting) annuity pensions for disability, early and normal retirees and their survivors, including: <br/> <ul> <li>EFT processing. </li> <li>Check processing and postage. </li> <li>Resolving failed, misdirected and lost payments. </li> <li>Paying, but not calculating, adjustments to pensions. For example, many systems pay retroactive adjustments to pensions initiated based on incomplete data. <li>Collecting overpayments. </li> <li>The processing of return payments from annuitants. </li> <li>Stopping pension payments upon  the death of an annuitant. </li> </ul> 2. Processing deductions from the gross pension payment. For example: <br/> <ul> <li>Processing and paying taxes and other governmental deductions, such as social security. </li> <li>Processing legally required deductions such as liens on wages ordered by a judge. </li> <li>Processing and effecting payment of optional deductions that the member can request, such as for health care or optional life insurance or union dues. </li> <li>Processing and mailing of check stubs or EFT payment advices. </li> <li>Processing and mailing of annual tax receipts to annuitants. </li> <li>Keeping track of the rules and regulations for deductions. </li> </ul>  3. Confirming payment eligibility. This includes: <br/>  <ul> <li>Cross referencing pension payrolls with death records. </li> <li>Obtaining proof that someone is alive. </li> <li>Checking eligibility. </li> </ul><br/>  If a sister organization performs any of the above tasks, then the costs incurred by the sister organization should be included here and in your Total Costs. <br/><br/>  Do NOT include: <br/>  <ul> <li>Maintaining banking, address and beneficiary data for retirees. These belong in 3c Data Not from Employers. </li> <li>The work of inflation adjustments. It belongs in 1b Pension Inceptions. "
        >
          <SurveyElement
            questionNumber="17"
            name="AdministerAnnuityPensionsYN"
            labelText="Do you administer annuity pensions?"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
          />
          <SurveyConditionalSegment
            showIf={{
              AdministerAnnuityPensionsYN: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="18"
              name="SACRSLatePayroll"
              labelText="Were any of your pension payrolls late vis-à-vis your normal payment cycle?"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
            />
            <SurveyConditionalSegment
              showIf={{
                SACRSLatePayroll: { not: CommonResponses.NO }
              }}
            >
              <SurveyElement
                questionNumber="18.a"
                name="SACRSLatePayrollHowMany"
                labelText="How many payrolls were late?"
                inputType={ElementType.NUMBER}
                format={NumberFormat.DECIMAL1}
                placeholder="#"
                subQuestion
                allowNA
              />
              <SurveyElement
                questionNumber="18.b"
                name="SACRSLatePayrollDays"
                labelText="On average, how many days late were they?"
                inputType={ElementType.NUMBER}
                format={NumberFormat.DECIMAL1}
                placeholder="# days"
                subQuestion
                allowNA
              />
            </SurveyConditionalSegment>
            <SurveyElement
              questionNumber="19"
              name="CheckPaymentsPct"
              labelText="What percentage of pensions are paid by check?"
              note="as opposed to Electronic Funds Transfer ('EFT')"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE}
              placeholder="%"
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection
          id="2"
          labelText="Pension Inceptions and Written Pension Estimates"
          helpText="<strong>Pension Inceptions and Written Pension Estimates</strong><br /><br />1. New Annuitants: calculating, finalizing and arranging annuity pensions to new payees (i.e., early and normal service retirements, death in-service or on-pension resulting in annuity payments to spouse or dependents, divorce that results in new annuity pension streams). Exclude disability inceptions (except Dutch systems). Disability belongs in 1e Disability. <br /><br />2. Changing the gross amount of pensions paid to existing pensioners (excluding disability pensions) including: <br /><ul><li>Adjusting pensions that were initiated based on incomplete or estimated data.</li><li>Reducing the annuity payment when pensioner begins receiving social security (NL: AOW, Canada: CPP).</li><li>Cost of living adjustments for pensioners.</li><li>Last survivor options that reduce the amount paid to the pensioner when a spouse dies.</li></ul>3. Time spent by the pension inception team on appeals about annuity pension inceptions. Exclude time and cost of legal staff or external legal counsel. Legal costs belong in 7d Legal and Rule Interpretation.<br /><br />4. Preparing and sending, by mail or email, customized written estimates in response to requests from individual members regarding:<br /><ul><li>Annuity pensions including early and service retirement.</li><li>Giving customized written insight into pension consequences of divorce, death, layoffs, taxes, gaps in pension coverage, etc.</li><li>Lump sum or commuted value payouts.</li></ul>"
        >
          <SurveyElement
            questionNumber="20"
            name="ChangedPersonalCircumstances"
            labelText="How many changes in gross amount of annuity pensions paid occurred as a result of changes in an individual annuitant's personal circumstances? "
            note='For example:  <ul> <li>When the spouse of an annuitant dies " last survivor" options result in decreases, and "pop-up" or "reversion" options result in increases. [Exclude annuitant deaths that result in new pensions paid to spouses.]</li> <li>When an annuitant or their beneficiary becomes eligible for social security, it often results in a reduction of the gross pension paid.</li> <li>Redesign of the payment option, appeal decisions, high low options shifting to low, etc.</li> </ul>'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            allowUnknown
          />
          <SurveyElement
            questionNumber="21"
            labelText="What percent of annuity inceptions for:"
          />
          <SurveyElement
            questionNumber="21.a"
            name="Q_110"
            labelText="Retiring active members are paid without an interruption of cash flow greater than 1 month between the final pay check and the first pension check?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE}
            placeholder="%"
            subQuestion
            allowUnknown
          />
          <SurveyElement
            questionNumber="21.b"
            name="Q_97bReverse"
            labelText="Survivors are paid without an interruption of cash flow between the pensioner's final pension check and the survivor's first pension check?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE}
            placeholder="%"
            subQuestion
            allowUnknown
          />
          <SurveyElement
            questionNumber="22"
            name="Q_111"
            labelText="Will you initiate a service retirement pension based on existing data or estimates, recognizing that you will have to finalize the payments later after you get final data?"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
          />
          <SurveyConditionalSegment
            showIf={{
              Q_111: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="22.a"
              name="Q_111a"
              labelText="What proportion of your service retirement inceptions to retiring active members was based on existing data or estimates?"
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE}
              placeholder="%"
              subQuestion
            />
            <SurveyElement
              questionNumber="22.b"
              name="Q_111c"
              labelText="On average, how many months did it take to finalize service retirement inceptions based on estimates?"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder="# months"
              allowUnknown
              subQuestion
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber="23"
            name="BirthMarriageCertificates"
            labelText="Do you require birth certificates and/or marriage certificates before incepting a pension?"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
          />
          <SurveyElement
            questionNumber="24"
            name="Q_160a"
            labelText="Do you require notarization of normal or early retirement applications?"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_SOME}
          />
          <SurveyElement
            questionNumber="24.a"
            name="Q_160aSomeDescr"
            labelText="Describe those that require versus those do not:"
            inputType={ElementType.TEXTAREA}
            showIf={{
              Q_160a: ["", "null", CommonResponses.SOME]
            }}
            subQuestion
          />
          <SurveyElement
            questionNumber="25"
            name="InactiveMissingBenefitsPct"
            labelText="What % of vested inactive members that reached their normal retirement age in the year have not received any benefits yet because mail has been returned and the member is unreachable?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE}
            placeholder="%"
            allowUnknown
          />
          <SurveyElement
            questionNumber="26"
            name="Q_104YN"
            labelText="Do you offer written pension estimates to members?"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO_SOME}
          />
          <SurveyConditionalSegment
            showIf={{
              Q_104YN: { not: CommonResponses.NO }
            }}
          >
            <SurveyElement
              questionNumber="27"
              name="Q_103"
              labelText="How many written pension estimates were sent in response to individual member requests?"
              note="Include estimates that were sent electronically. Exclude estimates that were prepared during a counseling session and not sent in advance."
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              allowNA
              allowUnknown
            />
            <SurveyElement
              questionNumber="28"
              name="DefineEstimate"
              labelText="When a member requests multiple different estimate scenarios, do you count each scenario as an 'estimate' or do you count the 'multiple request' as a single estimate?"
              inputType={ElementType.SELECT}
              options={SelectCombosPABS.EACH_SCENARIO_SINGLE_ESTIMATE}
              saveAsKey={true}
            />
            <SurveyElement
              questionNumber="28.a"
              name="DefineEstimateA"
              labelText="If you count each scenario, what is the approximate average number of scenarios per request by a member?"
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder="#"
              allowNA
              allowUnknown
              subQuestion
              showIf={{
                  DefineEstimate: { not: "single" }
              }}
            />
            <SurveyElement
              questionNumber="29"
              name="Q_105"
              labelText="On average, how many business days does it take to provide a written pension estimate from the time of initial request from a member?"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder="#"
              allowNA
              allowUnknown
            />
            <SurveyElement
              questionNumber="30"
              labelText="Do your written pension estimates (including cover letters, etc., sent with the estimate):"
            />
            <SurveyElement
              questionNumber="30.a"
              name="Q_109a"
              labelText="Clearly address if and how the pension is inflation protected (or not protected)?"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              subQuestion
            />
            <SurveyElement
              questionNumber="30.b"
              name="Q_109b"
              labelText="If your pension is coordinated with or reduced by social security (or CPP in Canada) is the impact explained?"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO_NA}
              subQuestion
            />
            <SurveyElement
              questionNumber="30.c"
              name="Q_109c"
              labelText="Discuss alternative scenarios that could improve the pension such as purchasing service credit or working longer?"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              subQuestion
            />
            <SurveyElement
              questionNumber="30.d"
              name="Q_109d"
              labelText="Model alternative retirement payment options?"
              inputType={ElementType.SELECT}
              options={SelectCombos.YES_NO}
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection
          id="3"
          labelText="Refunds, Withdrawals and Transfers-out"
          helpText="<strong>Withdrawals, Refunds, Transfers Out</strong> <br /><br />Payments that terminate your relationship with a member including:<br /><ul><li>Withdrawals and Refunds of contributions.</li><li>Lump sum and commuted value payments.</li><li>Pre-retirement death that results in a final payment (refund, commuted value, death payment).</li><li>One time death payments that are supplemental to the annuity payments. Do not include the cost of paying or stopping the final pension payment which belong in 1a Pension Payments.</li><li>Hardship withdrawals (including partials).</li><li>Excess contribution refunds (For example, 50% Rule Refunds in Canada).</li><li>Individual rollovers of DB monies to internal DC accounts which effectively terminate the DB pension entitlement.</li><li>Individual transfers-out of monies to authorized external systems.</li><li>Collective transfers-out when an employer exits your system.</li></ul><br />The activity also includes:<br /><ul><li>Providing written estimates of refunds and transfers-out (do not include estimates for Lump Sums and Commuted Value Payments which belong in 1b Pension Inceptions and Written Pension Estimates).</li><li>Calculating, arranging and making estimated and final payments.</li><li>Related tax deductions, filings and reporting sent to members and tax authorities.</li><li>Reminders to speed up processing by external parties.</li><li>Collecting overpayments of lump sums or other terminating payments.</li></ul>"
        >
          <SurveyElement
            questionNumber="31"
            name="NumberRefundEstimates"
            labelText="How many written estimates for refunds/terminations/transfer-outs did you prepare in response to member requests?"
            note="Include all estimates whether they result in a refund or not. Include estimates that were sent electronically."
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            allowUnknown
          />
          <SurveyElement
            questionNumber="32"
            name="FromInitialRequest"
            labelText="How long does it take on average, in business days, for you to complete an individual transfer-out to a member's new pension plan, including delays caused by external parties, beginning from the time of initial request by the member?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# business days"
            allowNA
            allowUnknown
          />
        </SurveySection>
        <SurveySection
          id="4"
          labelText="Purchases and Transfers-in"
          helpText="<b>Purchases and Transfers-in</b> <br><br><ul> <li>Service credit purchases such as purchases of refunded past service, military service, etc.</li> <li>Purchases that provide members with additional pensionable salary.</li> <li>Individual transfers-in/ rollover of monies from external retirement systems.</li> <li>Collective transfers-in such as when a new employer is merged into your system.</li></ul>  <br>The activity includes:<br/><ul> <li>Providing formal written estimates of purchases and transfers-in/ rollovers.</li> <li>Posting purchases and applying payments.</li> <li>Receiving purchase payments.</li> <li>Related tax reporting sent to members and tax authorities.</li> <li>Purchases applicant dealing directly with the Purchase division, subsequent to an initial request for a Purchase. </li></ul>"
        >
          <SurveyElement
            questionNumber="33"
            labelText="Number of actual:"
          />
          <SurveyElement
            questionNumber="33.a"
            name="NumberServicePurchases"
            labelText="Prior service credit purchases?"
            note="e.g., for prior refunded service, military service, etc."
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            subQuestion
          />
          <SurveyElement
            questionNumber="33.b"
            name="InServicePurchasesOthers"
            labelText="In-service credit purchases?"
            note="e.g., maternity, parental, sabbatical, educational, illness leaves."
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            allowUnknown
            subQuestion
          />
          <SurveyElement
            questionNumber="33.c"
            name="TopUpsOfSalary"
            labelText="Upgrades or 'Top-ups' where members can improve their pensionable salary (but not service credit)?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            subQuestion
          />
          <SurveyElement
            questionNumber="33.d"
            name="Q_204bActual"
            labelText="Upgrades where members can pay to upgrade from an older retirement formula to a new retirement formula?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            subQuestion
          />
          <SurveyElement
            questionNumber="33.e"
            name="Q_204cActual"
            labelText="Individual transfers-in from the member's previous pension plan?"
            note="For example, many systems have reciprocal agreements with 'sister' plans that permit members to transfer-in credit from their previous employer's pension plan to their new plan and vice versa. Do not include collective transfers-in."
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            subQuestion
          />
          <SurveyElement
            questionNumber="34"
            name="NumberPurchaseEstimates"
            labelText="How many written purchase, upgrade, or transfer-in estimates did you prepare in response to member requests?"
            note="Include all estimates whether these result in a purchase or not. Include estimates that were sent electronically."
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            allowUnknown
          />
          <SurveyElement
            questionNumber="35"
            name="Q_205"
            labelText="On average, how many business days does it take from the date of first request to provide a written service credit purchase cost?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="#"
            allowNA
            allowUnknown
          />
          <SurveyElement
            questionNumber="36"
            name="Q_225c"
            labelText="How long does it take on average, in months, for you to do individual transfers-in?"
            note="Include any delays caused by external parties."
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder="# months"
            allowNA
            allowUnknown
          />
        </SurveySection>
        <SurveySection
          id="5"
          labelText="Disability"
          helpText="<b>Disability</b> <br><br>Include only if you are responsible for the administration of non-optional long term disability, and/ or short term disability. Includes: <br/><ul> <li>Written disability estimates.</li> <li>Disability approval process.</li> <li>Applications and inceptions.</li> <li>Disability appeals and complaints, provided that they are not handled by your legal staff or external legal counsel. Legal costs belong in 7d Legal and Rule Interpretation.</li> <li>Monitoring and reviewing disabled pensioners and/ or temporarily disabled members for continuing entitlement, including checks on income and medical reviews.</li> <li>Checks on eligibility of disability payments.</li> <li>Rehabilitation of disability recipients (very few systems perform this activity).<li>Medical assessment reviews of new hires for eligibility for death and disability benefits.</li> </ul> Do not include if disability is an optional benefit for members. Instead include in 1g. Do not include insurance costs. If an insurance company administers the disability program on your behalf, and you cannot clearly separate the administration cost from the insurance cost, then treat disability as a third party administered benefit. Do not include paying disability pensions. This belongs in 1a Pension Payments. <br/></ul>"
        >
          <SurveyElement
            questionNumber="37"
            labelText="Do you administer:"
          />
          <SurveyElement
            questionNumber="37.a"
            name="Q_297a"
            labelText="Long-term disability/ disability pensions?"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            subQuestion
          />
          <SurveyElement
            questionNumber="37.b"
            name="Q_297b"
            labelText="Short-term disability?"
            inputType={ElementType.SELECT}
            options={SelectCombos.YES_NO}
            subQuestion
          />
          <SurveyConditionalSegment
            dependentQuestion={["Q_297a", "Q_297b"]}
            desiredValue={[CommonResponses.BLANK, CommonResponses.YES]}
          >
            <SurveyElement
              questionNumber="38"
              labelText="How many months, on average, does it take to return a decision on a disability application from:"
            />
            <SurveyElement
              questionNumber="38.a"
              name="Q_210"
              labelText="Date of initial request from a member?"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder="# months"
              allowNA
              allowUnknown
              subQuestion
            />
            <SurveyElement
              questionNumber="38.b"
              name="CompletedDisabilityAppTime"
              labelText="Date of receipt of all necessary documentation to complete an application?"
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder="# months"
              allowNA
              allowUnknown
              subQuestion
            />
          </SurveyConditionalSegment>
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  )
}